"use client";
import { motion } from "framer-motion";
import Link from "next/link";

interface CTAProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export default function CTA({
  href = "#",
  children,
  className = "",
  onClick,
}: CTAProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (href === "#") {
      e.preventDefault();
    }
    onClick?.(e);
  };

  return (
    <Link href={href} onClick={handleClick}>
      <motion.div
        className={`group relative inline-block px-6 py-3 rounded-full border-2 border-current overflow-hidden ${className}`}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.2 }}
      >
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-brand-teal via-brand-pink to-brand-yellow -z-10"
          initial={{ x: "-100%" }}
          whileHover={{ x: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        />
        <span className="relative">{children}</span>
      </motion.div>
    </Link>
  );
}
